import React from 'react';
import { Backdrop, CircularProgress, Typography, styled } from '@mui/material';
import { useAuth } from './hooks';
import { useSelector } from 'react-redux';
import { selectors as appSelectors } from './store/Application';

const Title = styled(Typography)(({ theme }) => ({
	color: theme.palette.common.white,
	letterSpacing: theme.spacing(2),
	fontSize: theme.spacing(4),
	paddingLeft: theme.spacing(4),
	filter: `drop-shadow(0px 0px 2px ${theme.palette.primary.main})`,
	marginBottom: theme.spacing(2)
}));

const Progress = styled(CircularProgress)(({ theme }) => ({
	margin: 4,
	color: theme.palette.common.white
}));

const InitTask = styled(Typography)(({ theme }) => ({
	color: theme.palette.common.white
}));

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column'
}));

const LoadContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: theme.palette.common.white
}));

const SplashScreen = (): JSX.Element => {
	const initTask = useSelector(appSelectors.getInitTask);
	const auth = useAuth();
	return (
		<StyledBackdrop open>
			<div className={'splash-back'} />
			{auth.currentAccount && (
				<div>
					<Title variant='body1'>
						IMAGE HUB
					</Title>
				</div>
			)}
			<LoadContainer>
				<Progress size={16} color={'inherit'} />
				<InitTask variant='body1' color={'inherit'}>
					{initTask}
				</InitTask>
			</LoadContainer>
		</StyledBackdrop>
	);
};
export default SplashScreen;
